// @flow

import {Tag, extractLinksFromMarkdocList, findMarkdocTag} from 'docs/util';

import type {MarkdocTagRegistration} from 'docs/markdoc';

export const CardGroupQuickLinks: MarkdocTagRegistration = {
  tag: 'card-group-quick-links',
  component: 'CardGroupQuickLinks',
  render(node, config) {
    const attributes = node.renderAttributes({}, config);
    const children = node.renderChildren(config);

    const list = findMarkdocTag(children, (tag) => tag.name === 'List');
    const links = list ? extractLinksFromMarkdocList(list) : [];

    return new Tag(this.tag, {...attributes, links}, children);
  },
};
